// extracted by mini-css-extract-plugin
export default {"select":"AddressForm_select__PouSC"};